import { Component } from '@angular/core';

@Component({
  selector: 'app-inactivity-dialog',
  templateUrl: './inactivity-dialog.component.html',
  styleUrls: ['./inactivity-dialog.component.css']
})
export class InactivityDialogComponent {

  constructor() {
  }

}
